import { Expose, Type } from 'class-transformer';
import { SubscriptionStatusEnum } from './subscription-status.enum';
import { GetSubscriptionResponseDto } from './get-subscription-response.dto';

export class GetMembershipResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'status' })
  status: SubscriptionStatusEnum;
  @Expose({ name: 'from_date' })
  fromDate: number;
  @Expose({ name: 'user_id' })
  userId: number;
  @Expose({ name: 'to_date' })
  toDate: number;
  @Expose({ name: 'subscription' })
  @Type(() => GetSubscriptionResponseDto)
  subscription: GetSubscriptionResponseDto;
}
